import { toast } from 'react-toastify';

// ─────────────────────────────────────────────────────────────────────────────
// The app's notification helper, built on react-toastify — the global toast
// system, whose <ToastContainer> is already mounted in index.js and which 275
// modules already use.
//
// ★ DO NOT USE CHAKRA'S `useToast` IN THIS APP.
// It mounts a second ThemeProvider and re-runs toCSSVar() on the app's frozen
// theme, which throws "Cannot assign to read only property 'base'" from
// analyzeBreakpoints — a full-screen runtime error overlay instead of a
// notification. It fails at the moment the toast fires, so it survives every
// check that does not exercise the failure path in a browser.
//
//   const notify = useAppToast();
//   notify.success('Invoice posted', 'INV-202607-0001 is now in the ledger.');
//   notify.error('Could not post', err?.data?.message);
//
// This began life in finance-core/_ui/toast.js, which now re-exports it.
// ─────────────────────────────────────────────────────────────────────────────

const Body = (title, description) => {
	if (!description) return title;
	return (
		<div>
			<div style={{ fontWeight: 600, lineHeight: 1.25 }}>{title}</div>
			<div style={{ fontSize: '0.85em', opacity: 0.9, marginTop: 2 }}>{description}</div>
		</div>
	);
};

const API = {
	success: (title, description) => toast.success(Body(title, description)),
	error: (title, description) => toast.error(Body(title, description), { autoClose: 7000 }),
	warning: (title, description) => toast.warn(Body(title, description)),
	info: (title, description) => toast.info(Body(title, description)),
	/** Convenience for API catch blocks. */
	apiError: (fallback, err) =>
		toast.error(Body(fallback, err?.data?.message || err?.message || 'Please try again.'), { autoClose: 7000 }),
};

export function useAppToast() {
	return API;
}

export default useAppToast;
